import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { provideTranslocoScope, TranslocoService } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BusinessModel, PricingInformation, WalletPaymentMethodType } from '@platform-frontend/marketplace';
import { YattaLangId } from '@platform-frontend/transloco';
import { InclusiveActionFilter, LoadingIndicatorService } from '@platform-frontend/ui-tools';
import { TypedChanges } from '@platform-frontend/util';
import { debounceTime, distinctUntilChanged, Observable, of, startWith, Subject, switchMap } from 'rxjs';
import { CHECKOUT_TRANSLOCO_SCOPE } from '../../../checkout-transloco-scope';
import { WalletPaymentData } from '../../model/wallet-payment-data';
import { WalletButtonEnvironment } from '../model/wallet-button-environment';
import { WalletButtonTextMode } from '../model/wallet-button-text-mode';

@UntilDestroy()
@Component({
  selector: 'yat-wallet-button',
  templateUrl: './wallet-button.component.html',
  styleUrls: ['./wallet-button.component.scss'],
  providers: [provideTranslocoScope(CHECKOUT_TRANSLOCO_SCOPE)]
})
export class WalletButtonComponent implements OnChanges, OnInit {
  constructor(private loadingIndicatorService: LoadingIndicatorService, private translocoService: TranslocoService) {}

  @Output()
  walletPaymentSuccessful: EventEmitter<WalletPaymentData> = new EventEmitter<WalletPaymentData>();

  @Input()
  walletButtonTextMode: WalletButtonTextMode = 'BUY';

  @Input()
  walletButtonEnvironment: WalletButtonEnvironment = 'LIVE';

  @Input()
  vendorName: string = '';

  @Input()
  debitDate: Date | null = null;

  @Input()
  paymentActionFilter: InclusiveActionFilter | null = null;

  @Input()
  activeWallet: WalletPaymentMethodType | null = null;

  @Input()
  pricingInformation: PricingInformation | 'LOADING' | null = null;

  @Input()
  businessModel: BusinessModel = 'B2B';

  isGooglePayReady: boolean = false;

  buttonLanguage$: Observable<YattaLangId>;
  paymentResponseHandled$: Observable<boolean> = of(false);
  private actionFilter$: Subject<InclusiveActionFilter | null> = new Subject();

  ngOnInit(): void {
    this.buttonLanguage$ = this.translocoService.langChanges$ as Observable<YattaLangId>;
    this.paymentResponseHandled$ = this.actionFilter$.pipe(
      startWith(this.paymentActionFilter || null),
      switchMap(filter => this.loadingIndicatorService.getIsPending(filter)),
      debounceTime(0),
      distinctUntilChanged()
    );
  }

  ngOnChanges(changes: TypedChanges<WalletButtonComponent>): void {
    if (changes.paymentActionFilter) {
      this.actionFilter$.next(this.paymentActionFilter || null);
    }
  }
}
